import { useState } from 'react';
import { readJsonPref, writeJsonPref } from '@utils/localJsonPref';

export type DocumentsView = 'list' | 'grid';

const VIEW_KEY = 'd-orca.documents.view';

function isView(value: unknown): value is DocumentsView {
  return value === 'list' || value === 'grid';
}

/**
 * Which renderer the folder pane uses — the table or the card grid. A
 * preference, not a place: it lives in localStorage (like the sidebar's
 * collapsed state), never in the URL, so a shared link opens the same folder
 * in whichever view the recipient prefers.
 */
export function useDocumentsView() {
  const [view, setViewState] = useState<DocumentsView>(() => {
    const stored = readJsonPref(VIEW_KEY);
    return isView(stored) ? stored : 'list';
  });

  function setView(next: DocumentsView) {
    setViewState(next);
    writeJsonPref(VIEW_KEY, next);
  }

  return { view, setView };
}
